import { StyleSheet } from 'aphrodite';
import { charmGray } from '../../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		padding: 20,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 10,
	},
	selectContainer: {
		width: '100%',
		maxWidth: 350,
	},
	textContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		gap: 8,
	},
	subtitle: {
		fontSize: 16,
		fontWeight: 600,
	},
	description: {
		fontSize: 12,
		fontWeight: 400,
		textAlign: 'start',
		color: charmGray,
	},
});
